import { request as __request } from '../core/request';
export class FrontendUserPointCardService {
    /**
     * 儲值
     * @returns any Success
     * @throws ApiError
     */
    static buy({ requestBody, }) {
        return __request({
            method: 'POST',
            path: `/api/frontend/user_stock/buy`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * [BASE] Search From UserPointCardEntity
     * @returns any Success
     * @throws ApiError
     */
    static findAll({ where, page, }) {
        return __request({
            method: 'GET',
            path: `/api/frontend/user_stock`,
            query: {
                'where': where,
                'page': page,
            },
        });
    }
    /**
     * [BASE] Batch Update To UserPointCardEntity
     * @returns void
     * @throws ApiError
     */
    static batchUpdate({ requestBody, }) {
        return __request({
            method: 'PUT',
            path: `/api/frontend/user_stock`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * [BASE] FindOne From UserPointCardEntity
     * @returns any Success
     * @throws ApiError
     */
    static findOne({ id, }) {
        return __request({
            method: 'GET',
            path: `/api/frontend/user_stock/${id}`,
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
